import { render, staticRenderFns } from "./PopupComfirmSave.vue?vue&type=template&id=bc0d50f2&scoped=true&lang=pug&"
import script from "./PopupComfirmSave.vue?vue&type=script&lang=coffee&"
export * from "./PopupComfirmSave.vue?vue&type=script&lang=coffee&"
import style0 from "./PopupComfirmSave.vue?vue&type=style&index=0&id=bc0d50f2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0d50f2",
  null
  
)

export default component.exports